import { IconButton, Typography, Chip } from '@mui/material';
import { DisclosureIcon } from '@wavetrak/theme';
import { useMaxWidthDesktopSmall } from 'hooks/useMediaQueries';
import cx from 'classnames';

import styles from './ForecastDayTablePaywall.module.scss';

interface Props {
  onClickCta?: () => void;
}

const ForecastDayTablePaywall: React.FC<Props> = ({ onClickCta }) => {
  const isMobileView = useMaxWidthDesktopSmall();

  const CTA_PATH = '/upgrade';

  const onClickCtaHandler = () => {
    if (onClickCta) {
      onClickCta();
    }
    window.location.href = CTA_PATH;
  };

  const paywallClasses = cx({
    [styles.paywall]: true,
    [styles.paywallDesktop]: !isMobileView,
  });

  const paywallContentClasses = cx({
    [styles.paywallContent]: true,
    [styles.paywallContentFreemium]: true,
  });

  const titleTextVariant = isMobileView ? 'callout1' : 'headline';

  return (
    <div className={paywallClasses} data-testid="forecast-day-table-paywall">
      <div className={paywallContentClasses}>
        {!isMobileView && (
          <Chip
            data-testid="premium-chip"
            label={
              <Typography variant="callout2" component="span" className={styles.chipText}>
                Premium
              </Typography>
            }
            size="small"
            className={styles.chip}
          />
        )}
        <Typography variant={titleTextVariant} component="p" className={styles.titleText}>
          Get 16 days of forecast
        </Typography>
        {!isMobileView && (
          <Typography variant="caption1" component="p">
            Extended forecast with detailed wave, wind, and weather conditions.
          </Typography>
        )}
        <IconButton
          aria-label="premium upgrade link"
          className={styles.ctaAction}
          disableFocusRipple
          disableRipple
          disableTouchRipple
          onClick={onClickCtaHandler}
          data-testid="forecast-day-table-paywall-cta"
        >
          <DisclosureIcon rotation={90} size={11} />
        </IconButton>
      </div>
    </div>
  );
};

export default ForecastDayTablePaywall;
